import { render, staticRenderFns } from "./ScheduleHome.vue?vue&type=template&id=bcbc2bde&scoped=true&"
import script from "./ScheduleHome.vue?vue&type=script&lang=ts&"
export * from "./ScheduleHome.vue?vue&type=script&lang=ts&"
import style0 from "./ScheduleHome.vue?vue&type=style&index=0&id=bcbc2bde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbc2bde",
  null
  
)

export default component.exports